import { useQuery } from '@apollo/client'
import { ClearanceSetupByCompany } from '../../types'
import {  GET_CLEARANCE_BY_COMPANY } from './operations'

interface ClearanceSetupProps {
  companyId: string
  onCompleted?: (data: ClearanceSetupByCompany) => void
}

export const useClearanceSetup = ({
  companyId,
  onCompleted
}: ClearanceSetupProps) =>  useQuery<ClearanceSetupByCompany>(GET_CLEARANCE_BY_COMPANY, {
  variables: { companyId },
  onCompleted
})
